<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
	<Layout>
		<header style="margin-bottom: 0px;"><Button @click="$router.push('/common/couponCodeList');">返回</Button></header>
		<Content :style="{'padding': '10px'}">
			<Breadcrumb :style="{margin: '5px 0'}">
				<BreadcrumbItem>通用管理 > <b>卡密列表</b></BreadcrumbItem>
			</Breadcrumb>
			<Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
				<span class="search_span_width">
					<span class="search_span_width_part1">卡密：</span>
					<Input v-model="search.coupon_code_sn" placeholder="请输入卡密" :style="{'width':'180px'}"></Input>
				</span>
				<span class="search_span_width">
					<span class="search_span_width_part1">用户ID：</span>
					<Input v-model="search.user_id" placeholder="请输入用户ID" :style="{'width':'180px'}"></Input>
				</span>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList()">搜索</Button>
			</Card>
			<Card>
				<p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
					<span :style="{'text-align':'center','float':'left'}">
						<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">生成卡密</Button>
					</span>
					<span :style="{'text-align':'center','float':'left'}">
						<Button type='primary' :style="{'margin-left':'5px'}" @click="exportSn()">导出</Button>
					</span>
				</p>
				<Card id="tableContent" >
					<Table :columns="tableColumns" row-key="id" update-show-children :data="recordList"></Table>
					<Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getList"/>
				</Card>
			</Card>
		</Content>
		<Modal v-model="showmodal" :footer-hide=true title="生成卡密">
			<Form ref="info" :model="info" :label-width="80" :rules="createRule">
				<FormItem label="生成数量" prop="num">
					<Input v-model="info.num"/>
				</FormItem>
				<FormItem label="开始时间" prop="begin_time">
					<DatePicker type="datetime"  :value="info.begin_time" format="yyyy-MM-dd HH:mm" @on-change="computePeriod($event, 0)" placeholder="有效期" style="width: 300px"></DatePicker>
				</FormItem>
				<FormItem label="结束时间" prop="end_time">
					<DatePicker type="datetime" :value="info.end_time" format="yyyy-MM-dd HH:mm" @on-change="computePeriod($event, 1)" placeholder="有效期" style="width: 300px"></DatePicker>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="createCouponSn()">提交</Button>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="showsmodal" :footer-hide=true title="发放卡密">
			<Form ref="sendinfo" :model="sendinfo" :label-width="80" :rules="sendRule">
				<FormItem label="客户手机号" prop="user_id">
					<Select
						v-model="sendinfo.user_id"
						filterable
						:remote-method="getUserList"
						:loading="loading2">
						<Option v-for="(option, index) in userList" :value="option.id" :key="index">{{option.mobile}}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="sendCouponSn()">确认</Button>
				</FormItem>
			</Form>
		</Modal>
	</Layout>
</template>
<script>
export default {
	data(){
		return {
			coupon_code_id:0,
			search:{
				coupon_code_sn:"",
				user_id:""
			},
			info:{
				coupon_code_id:0,
				begin_time:"",
				end_time:"",
				num:""
			},
			sendinfo:{
				id:0,
				user_id:0
			},
			showmodal:false,
			showsmodal:false,
			loading2:false,
			userList:[],
			recordList:[],
			recordTotal:0,
			page:1,
			createRule :{
				id:[
					{ required: true, message: '请选择卡密', trigger: 'blur' },
				],
				num:[
					{ required: true, message: '请填写生成数量', trigger: 'blur' }
				],
				begin_time:[
					{ required: true, message: '请选择开始时间', trigger: 'blur' }
				],
				end_time:[
					{ required: true, message: '请选择结束时间', trigger: 'blur' }
				],
			},
			sendRule :{
				id:[
					{ required: true, message: '请选择卡密', trigger: 'blur' },
				],
				user_id:[
					{ required: true, message: '请选择客户手机号', trigger: 'blur' }
				]
			},
			tableColumns:[
				{ title: 'ID', key: 'id', align: 'center' },
				{ title: '卡密', key: 'coupon_code_sn', align: 'center' },
				{ title: '有效开始时间', key: 'begin_time', align: 'center'},
				{ title: '有效结束时间', key: 'end_time', align: 'center'},
				{ title: '用户ID', key: 'user_id', align: 'center',
					render:(h,params) =>{
						if (params.row.user_id == 0) {
							var user_id = '-';
						}else {
							var user_id = params.row.user_id;
						}
						return h('span',{},user_id);
					}
				},
				{ title: '用户昵称', key: 'user_nickname', align: 'center',
					render:(h,params) =>{
						if (params.row.user_nickname == '') {
							var user_nickname = '-';
						}else {
							var user_nickname = params.row.user_nickname;
						}
						return h('span',{},user_nickname);
					}
				},
				{ title: '绑定时间', key: 'bind_time', align: 'center',
					render:(h,params) =>{
						if (params.row.bind_time == 0) {
							var bind_time = '-';
						}else {
							var bind_time = params.row.bind_time;
						}
						return h('span',{},bind_time);
					}
				},
				//{ title: '使用状态', key: 'bind_time', align: 'center'},
				{ title: '操作', key: 'action', align: 'center',
					render: (h, params) => {
						let btns = [];
						btns.push(
							h('Button', {
								props: { type: 'error', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.del(params.row.id);
									}
								}
							}, '删除'),
						);
						/*
						if (params.row.user_id == 0) {
							btns.push(
								h('Button', {
									props: { type: 'success', size: 'small' },
									style: { marginRight: '5px', marginBottom: '5px'},
									on: {
										click: () => {        
											this.sendinfo.id = params.row.id;
											this.sendinfo.user_id = 0;
											this.showsmodal = true;
										}
									}
								}, '发放'),
							);
						}
						*/
						return h("div", btns);
					}
				}
			],
		}
	},
	mounted:function(){
		this.coupon_code_id = this.$route.query.coupon_code_id ? this.$route.query.coupon_code_id : 0;
		this.getList();
	},
	computed:{},
	methods:{
		addModal(){
			this.info = {
				coupon_code_id:this.coupon_code_id,
				begin_time:"",
				end_time:"",
				num:""
			};
			this.showmodal = true;
		},
		closeModal(){
			this.showmodal = false;
			this.showsmodal = false;
		},
		exportSn(){
			this.$Modal.confirm({
				content: '<p>确认导出？</p>',
				onOk: () => {
					let p = {'coupon_code_id':this.coupon_code_id};
					let params = Object.assign(this.search, p);
					this.http1.post('/coupon_code/exportCouponSn', params).then(response=>{
						let data = response.data;
						if (data.code !== 0){
							alert(data.message);
						} else {
							this.$Notice.success({
								title: '导出成功',
								desc: data.data.url,
								duration: 0
							});
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				},
			});
		},
		getList(page = this.page){
			this.page = page;
			let p = {'coupon_code_id':this.coupon_code_id, 'page':page};
			let params = Object.assign(this.search, p);
			this.http1.get('/coupon_code/snList', {params:params}).then(response=>{
				let data = response.data;
				if (data.code !== 0){
					alert(data.message);
				} else {
					this.recordList = data.data.list;
					this.recordTotal = data.data.total;
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getUserList(query){
			if (query !== '') {
				this.loading2 = true;
				setTimeout(() => {
					this.loading2 = false;
					this.http.get('/admin/user/userList', {params:{mobile:query}}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							alert(data.message);
						} else {
							this.userList = data.data.list;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}, 200);
			}
		},
		del(id){
			this.$Modal.confirm({
				content: '<p>请确认是否删除该卡密？</p>',
				onOk: () => {
					this.showAllmodal = false;
					this.http1.post('/coupon_code/delSn', {id:id}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('删除成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				},
			});
		},
		computePeriod(e, type){
			if (type == 0) {
				this.info.begin_time = e;
			} else {
				this.info.end_time = e;
			}
		},
		createCouponSn(){
			this.$refs["info"].validate((valid) => {
				if(valid){
					this.showmodal = false;
					this.info.coupon_code_id = this.coupon_code_id;
					this.http1.post('/coupon_code/createCouponSn', this.info).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('生成成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}
			});
		},
		sendCouponSn(){
			this.$refs["sendinfo"].validate((valid) => {
				if(valid){
					this.showsmodal = false;
					this.http1.post('/coupon_code/sendCouponSn', this.sendinfo).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('发放成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}
			});
		},
	}
}
</script>
